import { render, staticRenderFns } from "./OrderContactInfo.vue?vue&type=template&id=0a8ef700&scoped=true&"
import script from "./OrderContactInfo.vue?vue&type=script&lang=js&"
export * from "./OrderContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderContactInfo.vue?vue&type=style&index=0&id=0a8ef700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ef700",
  null
  
)

export default component.exports